import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useClients(params: {
  page?: number;
  page_size?: number;
  search?: string;
  level_min?: number;
  level_max?: number;
  only_community?: boolean;
} = {}) {
  return useQuery({
    queryKey: ["clients", params],
    queryFn: () => api.listClients(params),
    staleTime: 60_000,
  });
}
